export default __webpack_public_path__ + "static/media/bag.3ce0bc78.jpg";